// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Antd from 'ant-design-vue'
import './assets/common.css'
import 'ant-design-vue/dist/antd.css'
import App from './App'
import util from './assets/util.js'
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import axios from './assets/js/axios.js';
import api from './config/api.js'
import router from './router'
import store from './store/store.js'
// import './util/rem'
Vue.prototype.locale=locale;
Vue.prototype.zhCN=zhCN;
Vue.config.productionTip = false;
Vue.prototype.$util = util;
Vue.prototype.$http = axios;
Vue.prototype.$api = api;
Vue.prototype.$store = store;
// Vue.prototype.Suserinfo=JSON.parse(sessionStorage.getItem("userInfo"));
 Vue.prototype.$upLoad='https://saas.qhy.51fxyf.com/api/common/upload2';
// Vue.prototype.$upLoad='http://api.50xue.com/platform/cc/upload/image';
//axios.defaults.baseURL = "https://api.50xue.com"
axios.defaults.baseURL = "https://saas.qhy.51fxyf.com"
Vue.use(Antd);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
window.addEventListener('popstate', function() {
  history.pushState(null, null, document.URL)
})



// WEBPACK FOOTER //
// ./src/main.js